import { ApiError } from '@/api/errors'
import { t, type TKey } from '@/i18n'
import type { ApiErrorCode } from '@/types/api'

/** Customs delete-check reasons the server sends as English sentences. */
const sentences: Record<string, string> = {
  'only a pending unposted customs declaration can be deleted': 'customs_not_pending',
  'Finance postings and procurement debt accruals are immutable': 'customs_posted',
  'the declaration has a customs accrual; it is removed by moving the truck back over the customs point': 'customs_accrued',
}

const known = new Set([
  'movement_source',
  'content_closed',
  'released',
  'activated_or_reversed_stage_charge',
  'active_customs_declarations',
  'activated_or_posted_stage_charge',
  'active_transport_units',
  'customs_not_pending',
  'customs_posted',
  'customs_accrued',
])

/**
 * The error a delete-check refusal raises, its reasons in the user's
 * language; a reason the admin does not know is shown as sent.
 */
export function deleteBlockedError(reasons: string[], status = 409, code: ApiErrorCode = 'CONFLICT') {
  const text = reasons
    .map((reason) => sentences[reason] ?? reason)
    .map((reason) => (known.has(reason) ? t(`procurement.deleteBlocked.reasons.${reason}` as TKey) : reason))
    .join('; ')
  return new ApiError({ status, code, message: t('procurement.deleteBlocked.message', { reasons: text }) })
}
